import React, { useRef, useState, useEffect } from "react";

const CameraView = () => {
  const videoRef = useRef(null);
  const [isCameraOn, setIsCameraOn] = useState(false);

  // Function to open the camera
  const openCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      videoRef.current.srcObject = stream;
      setIsCameraOn(true);
    } catch (err) {
      console.error("Camera access denied:", err);
      alert("Unable to access camera. Please allow permission.");
    }
  };

  // Function to stop the camera
  const stopCamera = () => {
    const stream = videoRef.current?.srcObject;
    const tracks = stream?.getTracks();
    tracks?.forEach((track) => track.stop());
    videoRef.current.srcObject = null;
    setIsCameraOn(false);
  };

  // Automatically open camera when the component mounts
  useEffect(() => {
    openCamera();

    // Stop camera when component unmounts (cleanup)
    return () => {
      stopCamera();
    };
  }, []);

  return (
    <div style={{ textAlign: "center" }}>
      <h2>Camera View</h2>

      <video
        ref={videoRef}
        autoPlay
        playsInline
        width="400"
        height="300"
        style={{ border: "2px solid #333", borderRadius: "8px" }}
      ></video>

      <div style={{ marginTop: "10px" }}>
        {isCameraOn ? (
          <button onClick={stopCamera}>Close Camera</button>
        ) : (
          <button onClick={openCamera}>Reopen Camera</button>
        )}
      </div>
    </div>
  );
};

export default CameraView;
